import { combineReducers } from '@reduxjs/toolkit';

import apiError from './apiError';
import isLoading from './isLoading';
import isReady from './isReady';

/**
 * @typedef {{
 *  apiError: import('./apiError').ApiErrorState,
 *  isLoading: import('./isLoading').IsLoadingState,
 *  isReady: import('./isReady').IsReadyState,
 * }} UnsubscribeState
 */

export default combineReducers({
  apiError,
  isLoading,
  isReady,
});
